import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import AppIcon from "@/components/AppIcon";

export default function CollectionsView() {
  const navigate = useNavigate();
  const [cols, setCols] = useState([]);

  useEffect(() => {
    api.collections().then(setCols).catch(() => setCols([]));
  }, []);

  return (
    <div className="ambient pb-28">
      <Header title="Подборки" subtitle="Тематические коллекции приложений" />
      <div className="relative z-10 px-4 pt-4 space-y-8">
        {cols.map((col) => (
          <section key={col.id} data-testid={`collection-${col.id}`}>
            <h2 className="font-display text-xl font-bold">{col.title}</h2>
            {col.subtitle && <p className="text-xs text-slate-400 mb-3">{col.subtitle}</p>}
            <div className="grid grid-cols-4 gap-3">
              {(col.apps || []).map((app) => (
                <div
                  key={app.id}
                  onClick={() => navigate(`/app/${app.id}`)}
                  className="cursor-pointer active:opacity-70 transition"
                >
                  <AppIcon src={app.icon} alt={app.name} size={72} className="rounded-2xl border border-white/10 w-full" />
                  <div className="mt-1 text-[11px] font-medium text-center truncate">{app.name}</div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
